import { render, staticRenderFns } from "./cancel-account.vue?vue&type=template&id=1247c34e&"
import script from "./cancel-account.vue?vue&type=script&lang=ts&"
export * from "./cancel-account.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports